import { debounce } from "../utils/global-utilities";

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    
    // eslint-disable-next-line no-console
    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
      const { target } = event;
      if(target.nodeName === 'INPUT') {
        target?.labels[0]?.setAttribute('aria-checked',event.target.checked)
      }
    }, 500);

    this.debouncedOnKeySubmit = debounce((event) => {
      this.onKeySubmitHandler(event);
    }, 500);




    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
    facetForm.addEventListener('change', this.debouncedOnSubmit.bind(this));
    facetForm.addEventListener('keydown', this.debouncedOnKeySubmit.bind(this));


    this.debouncedOnScroll = debounce(() => {
      this.onScrollCheckBottom();
    }, 0);

    window.addEventListener('scroll', this.debouncedOnScroll.bind(this));

    const filterNotDetails = this.querySelector('div[data-filter-element]');

    if (filterNotDetails) {
      const { filter } = filterNotDetails.dataset;
      document.addEventListener(`expand-filter:${filter}`, () => {
        const allFiltersDetails = this.querySelectorAll('details');
        allFiltersDetails.forEach((filterDetail) => {
          filterDetail.removeAttribute('open');
          filterDetail.classList.add('!duration-[.01s]');
        });
      });
    }
  }

  onScrollCheckBottom() {
    const targetPlace = document.querySelector("[data-target-place]");
    const mobileOpenFilters = document.querySelector("[data-target='mobile-open-filters']");
    
    if (!targetPlace || !mobileOpenFilters) return;
  
    const targetPlaceRect = targetPlace.getBoundingClientRect();
    const isAtTop = targetPlaceRect.top <= 0; 
  
    if (isAtTop) {
      mobileOpenFilters.classList.add('fixed');
      
      if (window.innerWidth > 320) {
        mobileOpenFilters.classList.add('translate-y-[97px]', '!top-0');
        mobileOpenFilters.classList.remove('translate-y-20', '!-top-20');
      } else {
        mobileOpenFilters.classList.add('translate-y-20', '!-top-20');
        mobileOpenFilters.classList.remove('translate-y-[97px]', '!top-0');
      }
      
    } else {
      mobileOpenFilters.classList.remove('fixed', 'translate-y-[97px]', '!top-0', 'translate-y-20', '!-top-20');
    }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();

    document.querySelector('[data-target="filters-loading-spinner"]').classList.remove('hidden');

    sections.forEach((section) => {
      // eslint-disable-next-line max-len
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      // eslint-disable-next-line no-unused-expressions
      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData
          = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        document.dispatchEvent(new CustomEvent('DOM:UPDATED'))
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const { html } = FacetFiltersForm.filterData.find(filterDataUrl);
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    document.dispatchEvent(new CustomEvent('DOM:UPDATED'))
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    const loadedPagination = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector('[data-target="paginate-container"]')
    const docPagination = document
      .querySelector('[data-target="paginate-container"]');
    if (docPagination)
      docPagination.innerHTML = (!loadedPagination) ? '' : loadedPagination.innerHTML;
  }

  static renderProductCount(html) {
    const parsedElements = new DOMParser().parseFromString(html, 'text/html');
    const count = parsedElements.getElementById('ProductCount-bar').innerHTML;
    const container = document.getElementById('ProductCount-bar');
    container.innerHTML = count;

    const activeFacetsRemove = parsedElements.querySelector('[active-facets] facet-remove');

    const clearAllButton = document.querySelector('[data-clear-all]').parentNode;
    if (!activeFacetsRemove) clearAllButton.classList.add('hidden');
    else clearAllButton.classList.remove('hidden');

    document.querySelector('[data-target="filters-loading-spinner"]').classList.add('hidden');
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm-drawer [data-filter-element], #FacetFiltersForm-bar [data-filter-element]'
    );

    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('[data-filter-element]') : undefined;
      return jsFilter
        ? element.dataset.index === jsFilter.dataset.index
        : false;
    };

    const facetsToRender =
      Array.from(facetDetailsElements)
        .filter((element) => !matchesIndex(element));

    facetsToRender.forEach((element) => {
      const content = element.innerHTML;
      const el = document
        // eslint-disable-next-line max-len
        .querySelector(`[data-filter-element][data-index="${element.dataset.index}"]`);
      el.innerHTML = content;
    });

    const selectedValuesToRender =
      Array.from(facetDetailsElements)
        .filter((element) => matchesIndex(element));

    selectedValuesToRender.forEach((element) => {
      if (!element.querySelector('[data-target="active-values"]')) return;
      const content = element.querySelector('[data-target="active-values"]').parentNode.innerHTML;
      const el = document
        // eslint-disable-next-line max-len
        .querySelector(`[data-filter-element][data-index="${element.dataset.index}"] [data-target="active-values"]`);
      el.parentNode.innerHTML = content;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['[active-facets]'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      const docActiveFacetElement = document.querySelector(selector);
      if (!activeFacetsElement || !docActiveFacetElement) return;
      docActiveFacetElement.innerHTML =
        activeFacetsElement.innerHTML;
      if (activeFacetsElement.querySelector('facet-remove')) docActiveFacetElement.classList.remove('hidden');
      else docActiveFacetElement.classList.add('hidden');
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const selector = '#FacetFiltersForm-drawer [data-filter="sort"]';

    if (!html.querySelector(selector)) return;
    document.querySelector(selector).innerHTML =
      html.querySelector(selector).innerHTML;
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
    document.querySelector('[data-filter-status]').textContent = ''
    setTimeout(()=>{
      document.querySelector('[data-filter-status]').textContent = 'filters have been updated, close the filters panel and view the updates'
      
    },800)
  }
  
  onKeySubmitHandler(event) {
    if (event.target.tagName === 'LABEL' && (event.key === ' ' || event.key === 'Enter')) {
      event.preventDefault();
      const targetInput = document.getElementById(event.target.getAttribute('for'));
      if (targetInput) {
        targetInput.checked = !targetInput.checked;
        targetInput.dispatchEvent(new Event('change', { bubbles: true }));
        
      }
     
    }
  }

  onSubmitHandler(event) {

    // TODO: dont use value of the same filter of another form than the form that was interacted with
    // issue: if user updates the engraving form in the filter bar, this logic is getting the value
    // of that form as well as the form that wasnt interacted with, causing conflicting information

    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    const forms = [];

    sortFilterForms.forEach((form) => {
      if (form.id === 'FacetFiltersForm-drawer' || form.id === 'FacetFiltersForm-bar') {
        forms.push(this.createSearchParams(form));
      }
    });
    this.onSubmitForm(forms.join('&'), event);
  }

  static updateURLHash(searchParams) {
    window.history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.querySelector('[data-product-grid]').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') === -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }

  
}

export default () => {
  FacetFiltersForm.filterData = [];
  FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
  FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
  if (!customElements.get('facet-filters-form'))
    customElements.define('facet-filters-form', FacetFiltersForm);
  FacetFiltersForm.setListeners();
}
